import {Moarify} from '@programming/moarify'

export function initListingHistory() {

  new Moarify({
    perPage: 10, 
    totalItems: $('#listingChangesList').attr('data-total-items'), 
    infiniteScroll: true,
    appendTo: $('#listingChangesList')
  });

  localizeDates();  
}


function localizeDates(){
  $('.changeDate').localTime('M/D/YY');
  $('.changeTime').localTime('time');
}
